import angular from 'angular';

angular
  .module('home')

  .factory('IndicatorService', [
    '$resource',
    'API_CONFIG',
    function($resource, API_CONFIG) {
      var Indicators = $resource(
        API_CONFIG.url + '/v1/indicators/:indicatorName',
        {},
        {
          // Compte le nombre de fichiers traités par un ladProvider
          countFileProcessedByLad: {
            method: 'GET',
            url: API_CONFIG.url + '/v1/indicators/fileProcessedByLad/:ladId/:hours'
          }
        }
      );

      return Indicators;
    }
  ]);
